
/* eslint func-names: 0 */
/* eslint no-multi-assign: 0 */
/* eslint consistent-return: 0 */
/* eslint no-cond-assign: 0 */

/* !
 * Angular JS Service inspired by jQuery Cookie Plugin v1.4.0
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */

const pluses = /\+/g;
const isLocal = isLocalEnvironment();
const cookie = {};
let cookieConfig;


function isLocalEnvironment() {

    return !!(CWCONFIG.cdn.indexOf('localhost:') > -1);

}

// force cookies to have the secure attribute enabled by default
// except for the local environment
function configureSecureFlag(allowInsecure) {

    if (isLocal) {

        return '';

    }

    return allowInsecure ? '' : '; secure';

}

function encode(s) {

    return cookieConfig.raw ? s : encodeURIComponent(s);

}

function decode(s) {

    return cookieConfig.raw ? s : decodeURIComponent(s);

}

function stringifyCookieValue(value) {

    return encode(cookieConfig.json ? angular.toJson(value) : String(value));

}

function parseCookieValue(s) {

    if (s.indexOf('"') === 0) {

        // This is a quoted cookie as according to RFC2068, unescape...
        s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');

    }

    try {

        // Replace server-side written pluses with spaces.
        // If we can't decode the cookie, ignore it, it's unusable.
        s = decodeURIComponent(s.replace(pluses, ' '));

    } catch (e) {

        return;

    }

    try {

        // If we can't parse the cookie, ignore it, it's unusable.
        return cookieConfig.json ? angular.fromJson(s) : s;

    } catch (e) {

        throw e;

    }

}

function read(s, converter) {

    const value = cookieConfig.raw ? s : parseCookieValue(s);
    return angular.isFunction(converter) ? converter(value) : value;

}

cookieConfig = cookie.set = cookie.get = (key, value, options) => {

    // Write
    if (value !== undefined && !angular.isFunction(value)) {

        options = angular.extend({}, options);

        if (typeof options.expires === 'number') {

            const days = options.expires;
            const t = options.expires = new Date();
            t.setDate(t.getDate() + days);

        }

        document.cookie = [
            encode(key), '=', stringifyCookieValue(value),
            // use expires attribute, max-age is not supported by IE
            options.expires ? `; expires=${options.expires.toUTCString()}` : '',
            options.path ? `; path=${options.path}` : '',
            options.domain ? `; domain=${options.domain}` : '',
            configureSecureFlag(options.allowInsecure),
        ].join('');

        return document.cookie;

    }

    // Read

    let result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling Cookie().
    const cookies = document.cookie ? document.cookie.split('; ') : [];

    for (let i = 0, l = cookies.length; i < l; i += 1) {

        const parts = cookies[i].split('=');
        const name = decode(parts.shift());
        let cookieTemp = parts.join('=');

        if (key && key === name) {

            // If second argument (value) is a function it's a converter...
            result = read(cookieTemp, value);
            break;

        }

        // Prevent storing a cookie that we couldn't decode.
        if (!key && (cookieTemp = read(cookieTemp)) !== undefined) {

            result[name] = cookieTemp;

        }

    }

    return result;

};

cookie.remove = (key, options) => {

    if (cookie.get(key) !== undefined) {

        // Must not alter options, thus extending a fresh object...
        cookie.set(key, '', angular.extend({}, options, { expires: -1 }));
        return true;

    }
    return false;

};

const Cookie = cookie;

export default Cookie;



// WEBPACK FOOTER //
// ./scripts/common/services/util/-RFC.Cookie.js